// extracted by mini-css-extract-plugin
export default {"DegradedBanner":"DegradedBanner_DegradedBanner__Mb8rx","Glyph":"DegradedBanner_Glyph__aXRbd","Text":"DegradedBanner_Text__4WKGa"};